import React, { ComponentProps, ReactElement, ReactNode } from 'react';

import PropTypes from 'prop-types';
import { CSSObject } from 'styled-components';

import { stylePropType, StylableComponent } from '@adsk/alloy-react-theme';

import SkeletonLoadingVertebra from './SkeletonLoadingVertebra';
import TableCell, { TableCellProps } from './TableCell';
import TableRow from './TableRow';
import useTableSize from '../hooks/useTableSize';
import { Themeable } from '../types';

const defaultRenderCell = (
  props: ComponentProps<typeof SkeletonLoadingVertebra>,
) => <SkeletonLoadingVertebra {...props} />;

type TableSkeletonLoadingRowProps = StylableComponent<HTMLDivElement> &
  Themeable & {
    tableCells: TableCellProps[];
    renderCell?: (
      props: ComponentProps<typeof SkeletonLoadingVertebra>,
    ) => ReactNode;
    foregroundColor?: string;
    backgroundColor?: string;
  };

const TableSkeletonLoadingRow = ({
  tableCells,
  renderCell = defaultRenderCell,
  foregroundColor,
  backgroundColor,
  style,
  ...props
}: TableSkeletonLoadingRowProps): ReactElement => {
  const tableSizeTheme = useTableSize(props.tableSize);

  return (
    <TableRow
      style={{ width: '100%', display: 'flex', ...(style as CSSObject) }}
      {...props}
    >
      {tableCells.map((tableCell, index) => {
        return (
          <TableCell key={index} {...tableCell}>
            {renderCell({
              width: tableCell.size,
              height: tableSizeTheme.rowHeight,
              foregroundColor,
              backgroundColor,
            })}
          </TableCell>
        );
      })}
    </TableRow>
  );
};
TableSkeletonLoadingRow.propTypes = {
  tableCells: PropTypes.arrayOf(PropTypes.shape({}).isRequired),
  style: stylePropType,
};

export default TableSkeletonLoadingRow;
